import React from 'react';
import Row from '@amzn/meridian/row';
import Text from '@amzn/meridian/text';
import Toggle from '@amzn/meridian/toggle';
import { ROW_BACKGROUND_HIGHLIGHT } from '../../shared/cssConstants';

interface SessionMergeModeToggle {
  label: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const containerStyle: React.CSSProperties = {
  padding: '6px 12px',
  border: '1px solid #CCD5DE',
  borderRadius: '8px',
  backgroundColor: ROW_BACKGROUND_HIGHLIGHT,
};

/**
 * Switches the session list into merge mode. Sits with the page actions, not the filters.
 * The label sits beside the switch, as on the page's other toggles.
 */
const SessionMergeModeToggleComponent: React.FC<SessionMergeModeToggle> = ({ label, checked, onChange }) => (
  <div style={containerStyle}>
    <Row spacing="200" alignmentVertical="center">
      <Toggle checked={checked} onChange={onChange} size="small" aria-label={label} />
      <Text type="b200">{label}</Text>
    </Row>
  </div>
);

export default SessionMergeModeToggleComponent;
